import src from "IMAGE";
export default { src, width: 121, height: 69, blurWidth: 0, blurHeight: 0};
